"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useTrapFocus = require("../../hooks/useTrapFocus");

var _closeModalContext = _interopRequireDefault(require("./close-modal-context"));

var _modalBody = require("./modal-body");

var _modalDialog = require("./modal-dialog");

var _modalFooter = require("./modal-footer");

var _modalHeader = require("./modal-header");

var _modal = require("./modal.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Modal = function Modal(_ref) {
  var props = _extends({}, _ref);

  var isOpen = props.isOpen,
      onClose = props.onClose,
      children = props.children,
      measure = props.measure,
      afterOpenModal = props.afterOpenModal,
      backdrop = props.backdrop;
  var containerRef = (0, _react.useRef)();
  var handleEscPress = (0, _react.useCallback)(function (e) {
    return e.keyCode === 27 && onClose();
  }, []);
  (0, _useTrapFocus.useTrapFocus)({
    containerRef: containerRef
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleEscPress);
    return function () {
      afterOpenModal && afterOpenModal();
      document.removeEventListener('keydown', handleEscPress);
    };
  }, []);
  return isOpen && /*#__PURE__*/_react.default.createElement(_modal.ModalWrapperStyled, _extends({
    measure: measure,
    backdrop: backdrop,
    ref: containerRef
  }, props), /*#__PURE__*/_react.default.createElement(_modal.BodyOverflowStyled, null), backdrop && /*#__PURE__*/_react.default.createElement(_modal.ModalBackgroundStyled, {
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement(_closeModalContext.default.Provider, {
    value: props
  }, /*#__PURE__*/_react.default.createElement(_modalDialog.ModalDialog, {
    measure: measure
  }, children)));
};

exports.Modal = Modal;
Modal.defaultProps = {
  isOpen: false,
  backdrop: true,
  measure: 'md'
};
_modalDialog.ModalDialog.displayName = 'Modal.Dialog';
_modalHeader.ModalHeader.displayName = 'Modal.Header';
_modalBody.ModalBody.displayName = 'Modal.Body';
_modalFooter.ModalFooter.displayName = 'Modal.Footer';
Modal.Dialog = _modalDialog.ModalDialog;
Modal.Header = _modalHeader.ModalHeader;
Modal.Body = _modalBody.ModalBody;
Modal.Footer = _modalFooter.ModalFooter;